import AddressSearch from "../AddressSearch";

const Intro = (props) => {
    return (<>
        <h1 className="bigger">Let's Get Started</h1>
        <p>Enter your address below to see if the i3 network is available.</p>
        <AddressSearch/>
    </>)
};

export default Intro;
